<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark :color="pages.header.back" fixed>
          <v-btn icon dark @click="fecharModal()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title :class="pages.header.class">Sobre</v-toolbar-title>
          <!--
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="$emit('fechar-modal')">Finalizar</v-btn>
          </v-toolbar-items>
          -->
        </v-toolbar>
        <div style="padding-top: 60px;"></div>
        <template>
            <template>
                <v-card flat>
                  <v-card-text class="content-sobre">
                    <template v-for="linha in content">
                      <div v-if="linha.tipo=='h'" class="subheading font-weight-bold" v-html="linha.text"></div>
                      <div v-else-if="linha.tipo=='t'" v-html="linha.text"></div>
                      <div v-else-if="linha.tipo=='l'" class="text-xs-center"><a :href="linha.href" target="_blank">{{linha.text}}</a></div>
                      <div v-else-if="linha.tipo=='f'" class="text-xs-center"><img :src="linha.img">
                      </div>
                      <div v-else-if="linha.tipo=='tf'">
                        <v-layout>
                          <v-flex xs6 v-html="linha.text"></v-flex>
                          <v-flex xs6><img :src="linha.img" width="100%"></v-flex>
                        </v-layout>
                      </div>
                      <div v-else-if="linha.tipo=='ft'">
                        <v-layout>
                          <v-flex xs6><img :src="linha.img" width="100%"></v-flex>
                          <v-flex xs6 v-html="linha.text"></v-flex>
                        </v-layout>
                      </div>
                      <template v-else-if="linha.tipo=='br'">
                        <br>
                      </template>
                      <div v-else>{{linha}}</div>
                    </template>
                    <br><br><br>
                  </v-card-text>
                    <!--

		content: [
			{tipo:"t",text: "teste de conteúdo html"},
			{tipo:"f",img: "https://pedirfood.com/fotos/20_logo_menor.jpg"},
			{tipo:"tf",text: "Texto Lado esquerdo",img: "https://pedirfood.com/fotos/20_logo_menor.jpg"},
			{tipo:"ft",text: "Texto Lado direito",img: "https://pedirfood.com/fotos/20_logo_menor.jpg"},
			{tipo:"l",text: "Abrir link",href: "https://pedirfood.com/"}
		]


                    <v-bottom-nav :active.sync="bottomNav" :value="true" app color="#82c14e" class="white--text pt-3">
                    <v-bottom-nav :active.sync="bottomNav" :value="true" app color="#000000" class="white--text pt-3">
                        -->
                    <v-bottom-nav  :value="true" app color="#1d1d1b" class="white--text pt-3">
                        {{creditos}}
                    </v-bottom-nav>
                </v-card>
            </template>
        </template>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
  ///import jquery from 'jquery';
  export default {
    props:['dialog','pages','content'],
    data () {
      return {
        creditos: "By pedirfood.com",
        //text: "Lorem ipsum dolor sit amet, mel at clita quando. Te sit oratio vituperatoribus, nam ad ipsum posidonium mediocritatem, explicari dissentiunt cu mea. Repudiare disputationi vim in, mollis iriure nec cu, alienum argumentum ius ad. Pri eu justo aeque torquatos."
      }
    },
    methods:{
      fecharModal(){
        this.$emit('click-dialog');
      }
    }
  }
</script>
<style>
img {
  max-width: 100%;
}
.content-sobre{
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}
</style>